module.exports = __webpack_public_path__ + "img/logo.27cd7ea0.png";